import React from 'react'
import { OptimizelyFeatureFlags } from 'constants/optimizely'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import HotelsPage from './HotelsPage'
import OldUiHotelsPage from '../OldUiHotelsPage'

function HotelsPageWrapper() {
  const hotelNewUiVerticalPage = !!useOptimizelyExperiment(OptimizelyFeatureFlags.croHotelNewUiVerticalPage)
  return hotelNewUiVerticalPage ? <HotelsPage /> : <OldUiHotelsPage />
}

export default HotelsPageWrapper
